import React, { memo } from 'react';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import { MediaQuery } from '@context/mediaQuery';
import { useHeaderStore } from '@store/header';

import { BLUR_BACKGROUND_PATHS, NAV_LINKS } from '@utils/constants';
import { HeaderAnimatedText } from './AnimatedText';
import { DesktopHeader } from './Headers/Desktop';
import { MobileHeader } from './Headers/Mobile';
import { NewMobileHamburgerSheet } from './NavMenu/NewMobileHamburger';

export const Header = memo(function Header({ hideMobileNav }: { hideMobileNav?: boolean }) {
  const { tablet } = MediaQuery.useContainer();
  const { isSearchOpen } = useHeaderStore();
  const { pathname } = useRouter();

  const isLandingPage = pathname === NAV_LINKS.Home;
  const isAboutPage = pathname === NAV_LINKS.About;

  const isBlurBackground = BLUR_BACKGROUND_PATHS.includes(pathname);
  const strokeColor: 'white' | 'black' = isBlurBackground ? 'white' : 'black';

  return (
    <>
      <header
        className={clsx(
          'top-0 z-header mx-auto',
          isBlurBackground ? 'absolute left-0 right-0 md:left-[52px] lt:left-[240px]' : 'relative',
          hideMobileNav ? 'hidden md:flex' : ' md:flex',
        )}
      >
        <div className="mx-auto w-full px-4 py-4 md:px-6 md:py-5 dt:max-w-content">
          <div className="hidden md:block">
            <DesktopHeader />
          </div>

          {isSearchOpen || hideMobileNav ? null : (
            <div className="md:hidden">
              <MobileHeader strokeColor={strokeColor} />
            </div>
          )}
          {isLandingPage || isAboutPage ? <HeaderAnimatedText /> : null}
        </div>
      </header>

      {!tablet && !hideMobileNav && <NewMobileHamburgerSheet />}
    </>
  );
});
